import type { ReactNode } from "react";

import { cn } from "../../lib/cn";

type CardProps = {
	children: ReactNode;
	className?: string;
};

export function Card({ children, className }: CardProps) {
	return (
		<div
			className={cn("rounded-xl border border-pastel-border bg-white shadow-pastel-sm", className)}
		>
			{children}
		</div>
	);
}

export function CardHeader({ children, className }: CardProps) {
	return <div className={cn("px-6 pt-6 pb-2", className)}>{children}</div>;
}

export function CardTitle({ children, className }: CardProps) {
	return <h3 className={cn("text-lg font-semibold text-pastel-black", className)}>{children}</h3>;
}

export function CardDescription({ children, className }: CardProps) {
	return <p className={cn("text-sm text-pastel-gray mt-1", className)}>{children}</p>;
}

export function CardContent({ children, className }: CardProps) {
	return <div className={cn("px-6 py-4", className)}>{children}</div>;
}

export function CardFooter({ children, className }: CardProps) {
	return <div className={cn("px-6 pb-6 pt-2 flex items-center gap-2", className)}>{children}</div>;
}
